<aside class="qc-sub-content order-content-detail__container" *ngIf="isSubContentPanelOpen">
	<diV class="qc-sub-content__header">Logs Detailed Information</diV>
	<div *ngIf="nexsysLog; else emptySelection">
		<div *ngFor="let log of nexsysLog; let even = even">
			<div class="card-detail__title" [ngClass]="{ filled: even }">
				<label class="data-field">{{ log.name }}</label>
				<label class="data-value">{{ log.value ? log.value : 'N/A' }}</label>
			</div>
		</div>
		<div class="card-detail__title" [ngClass]="{ filled: true }">
			<label class="data-field">
				<button class="btn-primary btn btn-sm" (click)="displayRequestInfo()">				

					Open Request Information 
					<i class="fas fa-brackets-curly"></i>
				</button></label
			>
		</div>	
	</div>
	<ng-template #emptySelection>
		<div class="empty-selection__content">
			<label class="empty-selection__icon"><i class="fas fa-file"></i></label>
			<label class="empty-selection__lbl">No Logs Selected</label>
			<label class="empty-selection-instruction__lbl"
				>Select an log from the list to see detailed information about</label
			>
		</div>
	</ng-template>
</aside>
